// src/components/Login.js
import React, { useContext } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { AuthContext } from '../AuthContext';
import { showSwalNotification } from '../../utils/SwalResponse';
import { useNavigate, useLocation } from 'react-router-dom';
// import { EventsContext } from '../../events/EventsContext';

const GoogleLoginButton = () => {
  const {userGoogleLogin} = useContext(AuthContext)
  // const { createBooking } = useContext(EventsContext)
  const navigate = useNavigate()

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const report = queryParams.get('rep'); 
  const eventId = queryParams.get('event_id');
  
  const handleSuccess = async (credentialResponse) => {
    const token = credentialResponse.credential;

    try {
      const response = await userGoogleLogin({token}) 
      showSwalNotification(response)
       if (response?.status === 'success'){
            if (!!report){
              if (report === 'submit'){
                navigate('/report')
                return;
              }
              // else if (report === 'reg_event' && eventId){
              //   await navigate(`/events/${eventId}`)
              //   const response = await createBooking(eventId)
              //   showSwalNotification(response)
              //   return;
              // }
              else if (report === 'attend' && eventId){
                await navigate(`/events/${eventId}/attendance`)
                return;
              }
  
            }
            navigate('/dashboard') // the users dashboard
            
            }
      
    } catch (err) {
      console.error("Login error", err.response?.data || err.message);
    }
  };

  return (
    <div>
      {/* <h2>Login with Google</h2> */}
      <GoogleLogin onSuccess={handleSuccess} onError={() => console.log("Login failed")} />
    </div>
  );
};

export default GoogleLoginButton;
